"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adal_angular_1 = __importDefault(require("adal-angular"));
var authenticationConst_1 = require("./authenticationConst");
exports.REDIRECT_URL = "/signin";
exports.EVENT_ADAL_ERROR = "eventAdalAccessTokenError";
var authOptions = {
    INSTANCE: process.env.REACT_APP_AUTH_INSTANCE || "",
    TENANT: process.env.REACT_APP_AUTH_TENANT || "",
    MULTITENANT: process.env.REACT_APP_AUTH_MULTITENANT || "",
    CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID || "",
    RESOURCE_ID: process.env.REACT_APP_AUTH_RESOURCE_ID || "",
};
exports.setAuthenticationOptions = function (options) {
    authOptions = __assign({}, authOptions, options);
};
//_adalContext lazy initialization
var _adalAuthContext = null;
exports.adalAuthContext = function () { return _adalAuthContext || initAdalContext(); };
function initAdalContext() {
    // workaround. to avoid AdalAuthenticationContext throw an error
    if (!authOptions.CLIENT_ID)
        return authenticationConst_1.AdalAuthenticationContext_Empty;
    var isMultitenant = authOptions.MULTITENANT && authOptions.MULTITENANT.toLowerCase() === "true";
    _adalAuthContext = new adal_angular_1.default({
        clientId: authOptions.CLIENT_ID,
        instance: authOptions.INSTANCE,
        tenant: isMultitenant ? "common" : authOptions.TENANT,
        postLogoutRedirectUri: window.location.origin,
        redirectUri: "" + window.location.origin + exports.REDIRECT_URL,
        navigateToLoginRequestUrl: false,
    });
    return _adalAuthContext;
}
exports.acquireToken = function (requireDispatch, resourceId) {
    if (requireDispatch === void 0) { requireDispatch = true; }
    if (resourceId === void 0) { resourceId = authOptions.RESOURCE_ID; }
    return new Promise(function (resolve, reject) {
        return exports.adalAuthContext().acquireToken(resourceId, function (error, token, errorType) {
            if (!error)
                return resolve(token);
            if (requireDispatch) {
                var detail = { error: error, errorType: errorType };
                window.dispatchEvent(new CustomEvent(exports.EVENT_ADAL_ERROR, { detail: detail }));
            }
            return reject({ error: error, token: token, errorType: errorType });
        });
    });
};
exports.getAdalContextCachedToken = function () {
    return exports.adalAuthContext().getCachedToken(authOptions.CLIENT_ID);
};
//# sourceMappingURL=authentication.js.map